import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { kpiConfigByIdMapAtom, kpiConfigByKeyMapAtom } from '../../../../../services/state/KPIConfigState';
import { kpiEntitiesToSelectItem, selectedKpisByCompanyPrefAtom } from '../../../state/ProfileViewSettings';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';

export function useKPISelectMenu() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const kpisByEntityField = useAtomValue(kpiConfigByKeyMapAtom);
  const kpisById = useAtomValue(kpiConfigByIdMapAtom);
  const [preference, setPreference] = useAtom(selectedKpisByCompanyPrefAtom(companyId));
  const selectedFields = kpiEntitiesToSelectItem(preference.selectedFields, kpisByEntityField);

  const handleDelete = useCallback(
    (id: string) => {
      const newValue = selectedFields
        .filter((item) => {
          return item.id !== Number(id);
        })
        .map((item) => item.entityField);
      setPreference({ selectedFields: newValue });
    },
    [selectedFields, setPreference]
  );

  const handleReorder = useCallback(
    (ids: string[]) => {
      const newSelectedFields = ids
        .map((id) => kpisById.get(Number(id))?.entityField ?? '')
        .filter((res) => res !== '');
      setPreference({ selectedFields: newSelectedFields });
    },
    [kpisById, setPreference]
  );

  return { handleDelete, handleReorder, selectedFields };
}
